export const localizedTypeName = (type) => {
  switch (type) {
    case 'folder':
      return s__('Portfolio|folder');
    case 'image':
      return s__('Portfolio|image');
    case 'video':
      return s__('Portfolio|video');
    case 'article':
      return s__('Portfolio|article');
    case 'external':
      return s__('Portfolio|external link');
    default:
      return s__('Portfolio|file');
  }
};
